// extracted by mini-css-extract-plugin
module.exports = {"container":"DataCard_container__37qhI","title":"DataCard_title__atlfP","details":"DataCard_details__1WFW-"};